<template>
    <div id="Layout">
        <el-row :gutter="20">
            <el-col :span="24" :offset="0">
                <h1><i class="el-icon-eleme"></i>外卖计算器</h1>
                <p>1.所有结果四舍五入取百分位,单位均为RMB(元)</p>
                <p>2.人员姓名以空格分开</p>
                <p>3.如果程序bug对您的财产造成损失,本程序不承担责任</p>
                <!-- <el-input placeholder="请输入订单金额,即实际支付金额,单位(元),下同." v-model="sum">
                    <template slot="prepend">订单金额</template>
                </el-input> -->
                <el-input placeholder="请输入配送费,免配送费则不填" v-model="psf" v-on:input="cal">
                    <template slot="prepend">配 送 费</template>
                </el-input>
                <el-input placeholder="请输入满减金额,无满减优惠则不填" v-model="mj" v-on:input="cal">
                    <template slot="prepend">满减金额</template>
                </el-input>
                <el-input placeholder="请输入打包费,没有打包费则不填" v-model="dbf" v-on:input="cal">
                    <template slot="prepend">打 包 费</template>
                </el-input>
                <el-input placeholder="请输入打红包,没有打包费则不填" v-model="hb" v-on:input="cal">
                    <template slot="prepend">红包金额</template>
                </el-input>
                <el-input placeholder="请输入人员姓名,以空格分隔" v-model="nameArr" @change="calName" clearable>
                    <template slot="prepend">人员姓名</template>
                </el-input>
            </el-col>
        </el-row>

        <el-row :gutter="20" v-show="false">
            <el-col :span="24" :offset="0">
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="选择订餐员工加入右侧, 之后填写每人满减前金额" name="1">
                            <div style="text-align: center">
                            <el-transfer
                            style="text-align: left; display: inline-block"
                            v-model="value3"
                            filterable
                            :filter-method="filterMethod"
                            filter-placeholder="输入姓名/拼音检索"
                            :render-content="renderFunc"
                            :titles="['不订餐的人', '要订餐的人']"
                            :button-texts="['到左边', '到右边']"
                            :format="{
                                noChecked: '${total}',
                                hasChecked: '${checked}/${total}'
                            }"
                            @change="handleChange"
                            :data="datag">
                            </el-transfer>
                        </div>

                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="24" :offset="0">
                <p>订餐人员列表：</p>
                <el-card class="box-card">
                    <el-input v-for="(k,v) in humans" :key="v" :placeholder="'请输入'+ datag[humans[v]].label +'点餐金额'" v-model="moneyes[v]" v-on:input="cal">
                        <template slot="prepend">{{ datag[humans[v]].label }}</template>
                    </el-input>

                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="24" :offset="0">
                <p>金额详情：</p>
                <template>
                    <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="money_one"
                        label="实际金额"
                        width="180">
                    </el-table-column>

                    </el-table>
                </template>

            </el-col>
        </el-row>
    </div>
</template>

<script>
    // const names = ['刘志才', '杨明', '蔡旭东', '陈默', '董春旭', '赵佳鑫', '刘永杰','王作旭','陈佳宇','陈学梅','周晓玲','张茹','张妍'];
    // const pinyins = ['liuzhicai', 'yangming', 'caixudong', 'chenmo', 'dongchunxu', 'zhaojiaxin', 'liuyongjie','wangzuoxu','chenjiayu','chenxuemei','zhouxiaoling','zhangru','zhangyan'];

export default {
    name: 'Layout',
    data(){
        // const generateData = _ => {
        //     const datag = [];
        //     names.forEach((name, i) => {
        //         datag.push({
        //             key: i,
        //             label: names[i],
        //             // pinyin: pinyins[i]
        //         });
        //     })
        //     console.log(datag);
        //     return datag;
        // }

        return{
            nameArr: '马振皓 王震 常伟 陈旭杰',
            names: [],//['刘志才', '杨明', '蔡旭东', '陈默', '董春旭', '赵佳鑫', '刘永杰','王作旭','陈佳宇','陈学梅','周晓玲','张茹','张妍'],
            sum: null,//订单金额
            all: null,//各项优惠总和
            psf: null,//配送费
            mj: null,//满减
            dbf: null,//打包费
            hb: null,//红包
            humans: [],//订餐人员总列表,注意，是序列
            human: null,//订餐人数
            activeNames: '1',//默认展开的项
            datag: null,//this.generateData(),//全部数据
            value3: [],//右侧默认选项
            renderFunc(h, option) {
                return <span>{ option.label }</span>;
            },
            filterMethod(query, item) {
                // console.log(query);
                // console.log(item);
                // console.log(item.pinyin.indexOf(query) > -1);
                // return item.pinyin.indexOf(query) > -1;
                return true;
            },
            tableData: [],
            moneyes: [],//每个人满减前的餐费
            yhPreson: 0,//每人享有的优惠
            trueMoney: [],//订餐人实际需要支付的餐费金额集合
        }
    },
    created() {
        this.calName();
    },
    methods: {
        unique(arr) {
            var result = [], hash = {};
            for (var i = 0, elem; (elem = arr[i]) != null; i++) {
                if (!hash[elem]) {
                    result.push(elem);
                    hash[elem] = true;
                }
            }
            return result;
        },
        calName() {
            this.names = this.nameArr.split(' ');
            // console.log(this.names);
            this.names = this.unique(this.names);
            this.nameArr = this.names.join(' ');
            this.datag = this.generateData();
            // console.log(this.datag);
            this.humans = [];
            for(let i=0;i<this.datag.length;i++){
                // console.log(this.datag[i]);
                this.humans.push(this.datag[i].key);
            }
            // console.log(this.humans);
        },
        generateData() {
            // console.log(this.names);
            let datag = [];
            // this.names.forEach((name, i) => {
            //     datag.push({
            //         key: i,
            //         label: names[i],
            //         // pinyin: pinyins[i]
            //     });
            // })
            for(let i=0;i<this.names.length;i++){
                datag.push({
                    key: i,
                    label: this.names[i],
                    // pinyin: pinyins[i]
                });
            }
            // console.log(datag);
            return datag;
        },
        handleChange: function(value, direction, movedKeys) {//右侧全部数据//转移方向//转移的数据
            this.humans = value;
            this.moneys = [];
            this.trueMoney = [];
            //表格数据处理
            this.tableData = [];
            //计算总金额
            this.sum = 0;
            this.trueMoney.map((k,v)=>{
                if( isNaN(k) ){
                    k = 0;
                }
                this.sum += k;
            });
            this.humans.map((k,v)=>{
                this.tableData.push({
                    name: this.names[k],
                    money_one: isNaN(Math.round( this.trueMoney[v] * 100)/100)?0:Math.round( this.trueMoney[v] * 100)/100
                });
            });
            this.tableData.push({
                name: '总金额',
                money_one: Math.round( this.sum * 100) / 100
            })

        },
        cal: function(){
            if( !this.humans.length ){
                return false;
            }
            if( !this.humans ){
                return false;
            }
            //打包费+配送费-满减-红包=总优惠
            if (!this.dbf || this.dbf < 0) {
                this.dbf = 0;
            }
            if (!this.psf || this.psf < 0) {
                this.psf = 0;
            }
            if (!this.mj || this.mj < 0) {
                this.mj = 0;
            }
            if (!this.hb || this.hb < 0) {
                this.hb = 0;
            }
            //所有优惠之和
            this.all = parseFloat(this.dbf) + parseFloat(this.psf) - parseFloat(this.mj) - parseFloat(this.hb);
            //平均每人享有的优惠
            this.yhPreson = this.all/this.humans.length;
            this.trueMoney = [];
            this.humans.map((k,v) => {
                this.trueMoney.push( parseFloat(this.moneyes[v]) + parseFloat(this.yhPreson) );
            });
            //重新渲染结果
            this.tableData = [];
            //计算总金额
            this.sum = 0;
            this.trueMoney.map((k,v)=>{
                if( isNaN(k) ){
                    k = 0;
                }
                this.sum += k;
            });
            this.humans.map((k,v)=>{
                this.tableData.push({
                    name: this.names[k],
                    money_one: isNaN(Math.round( this.trueMoney[v] * 100)/100)?0:Math.round( this.trueMoney[v] * 100)/100,
                    // money_one:  Math.round( this.trueMoney[v] * 100)/100
                });
            });
            this.tableData.push({
                name: '总金额',
                money_one: Math.round( this.sum * 100) / 100
            })
        }
    },
    components: {

    }
}
</script>

<style scoped>
    #Layout {
        width: 50%;
        margin: 0 auto;
    }
    @media screen and (max-width: 414px) {
        #Layout {
            width: 100%;
        }
    }
    .el-input{
        margin-top: 20px;
    }
    h1{
        color: rgb(47, 132, 255);
    }
    .el-row{
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue